var map = {
	"./abstract.jpg": "0c90",
	"./botanik.jpg": "44b4",
	"./cyberpank.jpg": "bd7a",
	"./death-stranding.jpg": "87ab",
	"./flower.jpg": "2929",
	"./forest.jpg": "3138",
	"./man.jpg": "e600",
	"./road-sun.jpg": "cd3d",
	"./space.jpg": "9cb0",
	"./spiderman.jpg": "af1d",
	"./trava.jpg": "b4ce",
	"./warcraft3.jpg": "04e4",
	"./winter.jpg": "e24b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07dd";